{
  "name": "ekowitryna-administration",
  "version": "1.0.3-dev2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "build-lib": "ng build ekowitryna-ui",
    "watch-lib": "ng build ekowitryna-ui --watch",
    "link-lib": "cd projects/ekowitryna-ui/dist && npm link && cd ../../../ && npm link @ekowitryna/ui --legacy-peer-deps",
    "dev-lib": "npm run build-lib && npm run link-lib",
    "dev": "npm start"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.3",
    "@angular/cdk": "^20.2.7",
    "@angular/common": "^20.3.3",
    "@angular/compiler": "^20.3.3",
    "@angular/core": "^20.3.3",
    "@angular/forms": "^20.3.3",
    "@angular/platform-browser": "^20.3.3",
    "@angular/platform-browser-dynamic": "^20.3.3",
    "@angular/router": "^20.3.3",
    "@ekowitryna/ui": "20.1.3-dev74",
    "@fontsource-variable/mulish": "^5.2.6",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-free": "^6.7.1",
    "@fortawesome/fontawesome-svg-core": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@mobiletract/account-service-angular-client": "1.16.3-dev1",
    "@mobiletract/auth-service-angular-client": "1.15.1-dev1",
    "@ngrx/effects": "^20.0.1",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "@ngx-translate/core": "^16.0.4",
    "@ngx-translate/http-loader": "^16.0.1",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/context-zone": "^2.2.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.208.0",
    "@opentelemetry/instrumentation": "^0.208.0",
    "@opentelemetry/instrumentation-document-load": "^0.54.0",
    "@opentelemetry/instrumentation-fetch": "^0.208.0",
    "@opentelemetry/instrumentation-xml-http-request": "^0.208.0",
    "@opentelemetry/resources": "^2.2.0",
    "@opentelemetry/sdk-trace-base": "^2.2.0",
    "@opentelemetry/sdk-trace-web": "^2.2.0",
    "@opentelemetry/semantic-conventions": "^1.38.0",
    "@primeng/themes": "^20.2.0",
    "country-flag-icons": "^1.5.19",
    "html2canvas": "^1.4.1",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.0",
    "lucide-angular": "^0.544.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.3",
    "@angular-eslint/builder": "20.2.0",
    "@angular-eslint/eslint-plugin": "20.2.0",
    "@angular-eslint/eslint-plugin-template": "20.2.0",
    "@angular-eslint/schematics": "20.2.0",
    "@angular-eslint/template-parser": "20.2.0",
    "@angular/cli": "^20.3.3",
    "@angular/compiler-cli": "^20.3.3",
    "@tailwindcss/postcss": "^4.0.13",
    "@types/jasmine": "~5.1.0",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "@typescript-eslint/utils": "^8.36.0",
    "autoprefixer": "^10.4.21",
    "eslint": "8.57.1",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "ng-packagr": "^20.0.0",
    "postcss": "^8.5.3",
    "tailwindcss": "^4.0.13",
    "typescript": "~5.8.0"
  }
}
